<template>
  <div class="xtInstance-list-container">
    <!--导航栏-->
    <van-nav-bar
      :title="$route.meta.title"
      left-arrow
    >
      <!--返回-->
      <van-icon
        slot="left"
        name="left"
        class-prefix="iconfont"
        @click="handleBack"
      />
    </van-nav-bar>
    <!--提示-->
    <van-notice-bar color="#1989fa" background="#ecf9ff" left-icon="info-o">
      如信息有误请与我中心联系，联系电话：{{ lxdh }}。
    </van-notice-bar>
    <!--登记业务列表项-->
    <XtInstanceListItem
      v-for="xtinstance in xtInstanceList"
      :key="xtinstance.iId"
      :xt-instance-info="xtinstance"
      finished-text="没有更多了"
      error-text="请求失败，点击重新加载"
    />
  </div>
</template>

<script type="text/javascript">
import { getXtInstanceList } from '@/api/xtInstance'
import { getSystemConfig } from '@/api/systemConfig.js'
import XtInstanceListItem from './components/XtInstanceListItem'
export default {
  components: {
    XtInstanceListItem
  },
  data() {
    return {
      xtInstanceList: [],
      lxdh: 'xxxx-xxxxxxxx' // 联系电话
    }
  },
  mounted() {
    this.loadXtInstanceList()
    this.loadSystemConfig()
  },
  methods: {
    loadXtInstanceList() {
      const realName = this.$store.getters.webUserInfo.realName
      const idNumber = this.$store.getters.webUserInfo.idNumber
      const open_id = this.$store.getters.webUserInfo.openId
      console.info(this.$store.getters.webUserInfo)
      getXtInstanceList({ realName: realName, idNumber: idNumber, open_id: open_id }).then(
        ({ data }) => {
          this.xtInstanceList = data
          console.info(this.xtInstanceList)
        }
      )
    },
    loadSystemConfig() {
      getSystemConfig({
        'key': 'DJXT_LXDH'
      }).then(response => {
        this.lxdh = response.data.value
      })
    },
    handleBack() {
      this.$router.go(-1)
    }
  }
}
</script>

<style lang="scss" scoped>
.xtInstance-list-container{
  background-color: #eee;
  padding-bottom: 10px;
}
</style>
